import { NonTimezoneSensitiveDate } from '@commenda/utils';
import moment from 'moment';
import {
  CalendarDateRange,
  CalendarViewMode,
  RbcEvent,
} from './calendar.types';

export const DAY_HEADERS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const getMonthGridRows = (date: Date): Date[][] => {
  const start = moment(date).startOf('month').startOf('week');
  const end = moment(date).endOf('month').endOf('week');
  const rows: Date[][] = [];
  const current = start.clone();
  while (current.isBefore(end) || current.isSame(end, 'day')) {
    const row: Date[] = [];
    for (let i = 0; i < 7; i++) {
      row.push(current.toDate());
      current.add(1, 'day');
    }
    rows.push(row);
  }
  return rows;
};

export const getViewLabel = (_view: CalendarViewMode, date: string): string =>
  NonTimezoneSensitiveDate.fromISO8601String(date).format('MMMM YYYY');

export const getViewDateRange = (
  _view: CalendarViewMode,
  date: string
): CalendarDateRange => {
  // Pad two weeks past the month on each side to cover the visible grid's leading/trailing
  // partial weeks. A superset is harmless — the grid keys events by exact day.
  const anchor = NonTimezoneSensitiveDate.fromISO8601String(date);

  return {
    startDate: anchor.startOf('month').subtract(14, 'days').toISO8601String(),
    endDate: anchor.endOf('month').add(14, 'days').toISO8601String(),
  };
};

export const groupEventsByDate = (
  events: RbcEvent[]
): Map<string, RbcEvent[]> => {
  const map = new Map<string, RbcEvent[]>();
  for (const event of events) {
    const key = moment(event.start).format('YYYY-MM-DD');
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(event);
  }
  return map;
};

export const navigateDate = (
  date: string,
  direction: 'PREV' | 'NEXT' | 'TODAY'
): string => {
  if (direction === 'TODAY')
    return NonTimezoneSensitiveDate.now().toISO8601String();

  return NonTimezoneSensitiveDate.fromISO8601String(date)
    .add(direction === 'NEXT' ? 1 : -1, 'months')
    .toISO8601String();
};
